export function turkishNumberWithSuffix(num) {
  if (typeof num !== 'number') {
    throw new Error('This function expects a number.');
  }

  const numStr = num.toLocaleString('tr');
  const numStrAfterFloatingPoint = numStr.slice(numStr.lastIndexOf(',') + 1);
  const lastDigit = numStrAfterFloatingPoint.slice(-1);
  let secondToLastDigit;
  let thirdToLastDigit;

  switch (lastDigit) {
  case '1':
  case '2':
  case '5':
  case '7':
  case '8':
    return `${numStr}'lik`;
  case '3':
  case '4':
    return `${numStr}'lük`;
  case '6':
    return `${numStr}'lık`;
  case '9':
    return `${numStr}'luk`;
  case '0':
    // 0 or *.0
    if (numStrAfterFloatingPoint.length === 1) return `${numStr}'lık`;

    // *0 or *.*0
    secondToLastDigit = numStrAfterFloatingPoint.slice(-2, -1);
    switch (secondToLastDigit) {
    case '1':
    case '3':
      return `${numStr}'luk`;
    case '2':
    case '5':
    case '7':
    case '8':
      return `${numStr}'lik`;
    case '4':
    case '6':
    case '9':
      return `${numStr}'lık`;
    case '0':
      // 00 or *.00
      if (numStrAfterFloatingPoint.length === 2) return `${numStr}'lık`;

      // *00 or *.*00
      thirdToLastDigit = numStrAfterFloatingPoint.slice(-3, -2);
      switch (thirdToLastDigit) {
      case '1':
      case '2':
      case '3':
      case '4':
      case '5':
      case '6':
      case '7':
      case '8':
      case '9':
        return `${numStr}'lük`;
      case '0':
        // 000 or *.000
        if (numStrAfterFloatingPoint.length === 3) return `${numStr}'lık`;

        // *000 or *.*000
        return `${numStr}'lik`;
      default:
        throw new Error('Invalid input.');
      }
    default:
      throw new Error('Invalid input.');
    }
  default:
    throw new Error('Invalid input.');
  }
}
